<!-- <div class="breadcrumb-bar"> -->
<!-- <div class="breadcrumb"> -->
<!-- <span class="breadcrumb-link" [routerLink]="['/dashboard']">Dashboard</span> -->
<!-- <span class="breadcrumb-sep" aria-hidden="true"></span>
    <span class="breadcrumb-current">Help</span> -->
<!--</div>
</div>-->

<!-- <main class="page-content">
  <section class="content-card">
   <h1 class="page-title">{{ pageTitle }}</h1>
    <p class="page-copy">Dashboard Page.</p>
  </section>
</main> -->

@if (actionItemsLoading || dashboardCountsLoading) {
<div class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>
}

<main class="main-content">
  <div class="page-header">
    <h1 class="page-title">Executive Summary Dashboard</h1>
  </div>


  <div class="filter-panel">
    <div class="filter-row">
      <div class="filter-group">
        <label class="filter-label">Financial Year</label>
        <div class="financial-year-select" [class.financial-year-select--open]="financialYearDropdownOpen">
          <button type="button" class="filter-select financial-year-toggle" (click)="toggleFinancialYearDropdown()">
            <span class="financial-year-toggle-label" [title]="financialYearLabel">{{ financialYearLabel }}</span>
          </button>
          <div class="financial-year-panel" *ngIf="financialYearDropdownOpen">
            <ul class="financial-year-list">
              <li class="financial-year-item" *ngIf="financialYears.length">
                <label>
                  <input type="checkbox" [checked]="allFinancialYearsSelected"
                    (change)="selectAllFinancialYears()" />
                  All Financial Years
                </label>
              </li>
              <li class="financial-year-item" *ngFor="let fy of financialYears">
                <label>
                  <input type="checkbox" [checked]="selectedFinancialYears.includes(fy)" (change)="toggleFinancialYear(fy)" />
                  {{ fy }}
                </label>
              </li>
              <li class="financial-year-empty" *ngIf="financialYears.length === 0">No financial years found</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Quarter</label>
        <div class="quarter-select" [class.quarter-select--open]="quarterDropdownOpen">
          <button type="button" class="filter-select quarter-toggle" (click)="toggleQuarterDropdown()">
            <span class="quarter-toggle-label">{{ quarterLabel }}</span>
          </button>
          <div class="quarter-panel" *ngIf="quarterDropdownOpen">
            <ul class="quarter-list">
              <li class="quarter-item">
                <label>
                  <input type="checkbox" [checked]="allQuartersSelected" (change)="selectAllQuarters()" />
                  All Quarters
                </label>
              </li>
              <li class="quarter-item" *ngFor="let q of quarters">
                <label>
                  <input type="checkbox" [checked]="selectedQuarters.includes(q)" (change)="toggleQuarter(q)" />
                  {{ q }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Month</label>
        <div class="month-select" [class.month-select--open]="monthDropdownOpen">
          <button type="button" class="filter-select month-toggle" (click)="toggleMonthDropdown()">
            <span class="month-toggle-label" [title]="monthLabel">{{ monthLabel }}</span>
          </button>
          <div class="month-panel" *ngIf="monthDropdownOpen">
            <ul class="month-list">
              <li class="month-item" *ngIf="availableMonths.length">
                <label>
                  <input type="checkbox" [checked]="allMonthsSelected" (change)="selectAllMonths()" />
                  All Months
                </label>
              </li>
              <li class="month-item" *ngFor="let month of availableMonths">
                <label>
                  <input type="checkbox" [checked]="selectedMonths.includes(month)" (change)="toggleMonth(month)" />
                  {{ month }}
                </label>
              </li>
              <li class="month-empty" *ngIf="availableMonths.length === 0">Select a quarter first</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Team Members</label>
        <div class="team-members-select" [class.team-members-select--open]="teamMembersDropdownOpen">
          <button type="button" class="filter-select team-members-toggle" (click)="toggleTeamMembersDropdown()">
            <span class="team-members-toggle-label" [title]="teamMembersLabel">{{ teamMembersLabel }}</span>
          </button>
          <div class="team-members-panel" *ngIf="teamMembersDropdownOpen">
            <input type="text" class="team-members-search" placeholder="Search team members..."
              [(ngModel)]="teamMembersSearchTerm" (click)="$event.stopPropagation()" />
            <ul class="team-members-list">
              <li class="team-members-item">
                <label>
                  <input type="checkbox" [checked]="allTeamsChecked" (change)="selectAllTeams()" />
                  All Teams
                </label>
              </li>
              <li class="team-members-item" *ngFor="let member of filteredTeamMembersList">
                <label>
                  <input type="checkbox" [checked]="allTeamsChecked || selectedTeamMembers.includes(member.value)"
                    (change)="toggleTeamMember(member.value)" />
                  {{ member.label }}
                </label>
              </li>
              <li class="team-members-empty" *ngIf="filteredTeamMembersList.length === 0">No team members found</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Client Name</label>
        <div class="client-name-select" [class.client-name-select--open]="clientDropdownOpen">
          <button type="button" class="filter-select client-name-toggle" (click)="toggleClientDropdown()">
            <span class="client-name-toggle-label">{{ filters.client || 'All Clients' }}</span>
          </button>
          <div class="client-name-panel" *ngIf="clientDropdownOpen">
            <input type="text" class="client-name-search" placeholder="Search client..." [(ngModel)]="clientSearchTerm"
              (click)="$event.stopPropagation()" />
            <ul class="client-name-list">
              <li class="client-name-item" [class.client-name-item--selected]="!filters.client"
                (click)="selectClient('')">All Clients</li>
              <li class="client-name-item" [class.client-name-item--selected]="filters.client === name"
                *ngFor="let name of filteredClientNames" (click)="selectClient(name)">
                {{ name }}
              </li>
              <li class="client-name-empty" *ngIf="filteredClientNames.length === 0">No clients found</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-row">
      <div class="filter-group">
        <label class="filter-label">Region</label>
        <div class="client-name-select geo-select" [class.client-name-select--open]="openGeoDropdown === 'region'">
          <button type="button" class="filter-select client-name-toggle" (click)="toggleGeoDropdown('region')">
            <span class="client-name-toggle-label">{{ filters.region || 'All Regions' }}</span>
          </button>
          <div class="client-name-panel" *ngIf="openGeoDropdown === 'region'">
            <input type="text" class="client-name-search" placeholder="Search region..." [(ngModel)]="geoSearchTerm"
              (click)="$event.stopPropagation()" />
            <ul class="client-name-list">
              <li class="client-name-item" [class.client-name-item--selected]="filters.region === 'All Regions'"
                (click)="selectRegion('All Regions')">All Regions</li>
              <li class="client-name-item" [class.client-name-item--selected]="filters.region === name"
                *ngFor="let name of filterGeo(regionOptions)" (click)="selectRegion(name)">{{ name }}</li>
              <li class="client-name-empty" *ngIf="filterGeo(regionOptions).length === 0">No regions found</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Country</label>
        <div class="client-name-select geo-select" [class.client-name-select--open]="openGeoDropdown === 'country'">
          <button type="button" class="filter-select client-name-toggle" (click)="toggleGeoDropdown('country')">
            <span class="client-name-toggle-label">{{ filters.country || 'All Countries' }}</span>
          </button>
          <div class="client-name-panel" *ngIf="openGeoDropdown === 'country'">
            <input type="text" class="client-name-search" placeholder="Search country..." [(ngModel)]="geoSearchTerm"
              (click)="$event.stopPropagation()" />
            <ul class="client-name-list">
              <li class="client-name-item" [class.client-name-item--selected]="!filters.country"
                (click)="selectCountry('')">All Countries</li>
              <li class="client-name-item" [class.client-name-item--selected]="filters.country === name"
                *ngFor="let name of filterGeo(countryOptions)" (click)="selectCountry(name)">{{ name }}</li>
              <li class="client-name-empty" *ngIf="filterGeo(countryOptions).length === 0">No countries found</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Location</label>
        <div class="client-name-select geo-select" [class.client-name-select--open]="openGeoDropdown === 'location'">
          <button type="button" class="filter-select client-name-toggle" (click)="toggleGeoDropdown('location')">
            <span class="client-name-toggle-label">{{ filters.location || 'All Locations' }}</span>
          </button>
          <div class="client-name-panel" *ngIf="openGeoDropdown === 'location'">
            <input type="text" class="client-name-search" placeholder="Search location..." [(ngModel)]="geoSearchTerm"
              (click)="$event.stopPropagation()" />
            <ul class="client-name-list">
              <li class="client-name-item" [class.client-name-item--selected]="!filters.location"
                (click)="selectLocation('')">All Locations</li>
              <li class="client-name-item" [class.client-name-item--selected]="filters.location === name"
                *ngFor="let name of filterGeo(locationOptions)" (click)="selectLocation(name)">{{ name }}</li>
              <li class="client-name-empty" *ngIf="filterGeo(locationOptions).length === 0">No locations found</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">Type of Review</label>
        <div class="review-type-select" [class.review-type-select--open]="reviewTypeDropdownOpen">
          <button type="button" class="filter-select review-type-toggle" (click)="toggleReviewTypeDropdown()">
            <span class="review-type-toggle-label">{{ reviewTypeLabel }}</span>
          </button>
          <div class="review-type-panel" *ngIf="reviewTypeDropdownOpen">
            <ul class="review-type-list">
              <li class="review-type-item">
                <label>
                  <input type="checkbox" [checked]="allReviewTypesSelected"
                    (change)="selectAllReviewTypes()" />
                  All Types
                </label>
              </li>
              <li class="review-type-item" *ngFor="let rt of reviewType">
                <label>
                  <input type="checkbox" [checked]="selectedReviewTypeIds.includes(rt.id)"
                    (change)="toggleReviewType(rt.id)" />
                  {{ rt.name }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-group reset-group">
        <button class="reset-btn" (click)="resetFilters()">RESET FILTER</button>
      </div>
    </div>
  </div>

  <div class="panels-grid">
    <div class="panels-left">
      <app-review-management-dashboard [reviewDistribution]="dashboardData?.ReviewDistribution"
        [reviewStatusCounts]="dashboardData?.ReviewStatusCounts"
        [reviewStatusCategoriesCounts]="dashboardData?.ReviewStatusCategoriesCounts"
        [overallReportReviewRating]="dashboardData?.OverallReportReviewRating"
        [specialProjectCount]="dashboardData?.SpecialProjectCount"
        (tileClick)="onReviewManagementTileClick($event)"></app-review-management-dashboard>
      <app-risk-management-dashboard [issueCategory]="dashboardData?.IssueCategory"
        [issueRating]="dashboardData?.IssueRating"
        [actionPlanCounts]="dashboardData?.ActionPlans"
        (tileClick)="onRiskManagementTileClick($event)"></app-risk-management-dashboard>
      <app-issue-category-dashboard
        [issuePerCategory]="dashboardData?.IssuePerCategory"
        (tileClick)="onRiskManagementTileClick($event)"></app-issue-category-dashboard>
    </div>
    <div class="panels-right">
      <app-action-required-dashboard [rawItems]="rawActionItems"
        (loadingChange)="actionItemsLoading = $event"></app-action-required-dashboard>
    </div>
  </div>
</main>